// src/components/layout/Navbar.js
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

function Navbar() {
  const { currentUser, userRole, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Failed to log out', error);
    }
  };

  // Determine dashboard link based on user role
  const getDashboardLink = () => {
    if (userRole === 'admin') {
      return '/admin';  // Change to '/admin' instead of '/admin/dashboard'
    } else if (userRole === 'mentor') {
      return '/mentor';
    } else {
      return '/learner';
    }
  };

  return (
    <nav className="navbar">
      <div className="navbar-brand">
        <Link to="/">Learning Portfolio</Link>
      </div>
      
      <div className="navbar-links">
        {currentUser ? (
          <>
            <Link to={getDashboardLink()}>Dashboard</Link>
            <button onClick={handleLogout} className="logout-btn">Logout</button>
          </>
        ) : (
          <>
            <Link to="/login">Login</Link>
            {/* Registration link removed */}
          </>
        )}
      </div>
    </nav>
  );
}

export default Navbar;